import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import {
  LettersOfMedicalNecessity,
} from '../LettersOfMedicalNecessity.types';

interface Props {
  id?: string;
}

const useGetLmnItemQuery = ({ id }: Props) => {
  const { data, isLoading } = useQuery(
    [API_URL.DOCUMENTS_RECEIPTS_FILES, id],
    () => api.get(API_URL.LETTERS_OF_MEDICAL_NECESSITY_BY_ID(id || '')),
    {
      retry: 0,
      enabled: !!id,
    }
  );

  const lmnItem: LettersOfMedicalNecessity = useMemo(() => {
    const formattedItem: LettersOfMedicalNecessity = {
      id: data?.data?.id ? `${data.data.id}` : undefined,
      name: data?.data?.name,
      description: data?.data?.description,
      validFrom: data?.data?.valid_from as unknown as string,
      validTo: data?.data?.valid_to as unknown as string,
      documentId: data?.data?.document_id ? `${data.data.document_id}` : undefined,
      employeeId: data?.data?.employee_id ? `${data.data.employee_id}` : undefined,
      organizationId: data?.data?.organization_id ? `${data.data.organization_id}` : undefined,
      organizationPath: data?.data?.organization_path,
      // TODO: this field is absent in the DTO
      // @ts-ignore
      claimIds: data?.data?.claim_ids?.map((id) => `${id}`) || [],
      // TODO: this field is absent in the DTO
      // @ts-ignore
      providerId: data?.data?.provider_id ? `${data.data.provider_id}` : undefined,
      createdAt: data?.data?.created_at as unknown as string,
    };
    return formattedItem;
  }, [data]);

  return {
    lmnItem,
    isLoading,
  };
};

export default useGetLmnItemQuery;
